import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ArrowRight, Plus } from "lucide-react";

// Acceso a una vista: lo usan las páginas hub (Root) y las pestañas de
// Finanzas. Toda la tarjeta es clicable (stretched-link) y se ve como tal:
// icono del módulo, título con flecha, una línea que dice qué hay adentro y,
// si aplica, un dato en la esquina (meta) y una acción directa en el pie.
const clickable = (onClick) => (event) => {
  event.preventDefault();
  onClick();
};

const HubLinkCard = ({ to, onClick, icon, color = "primary", title, description, meta, action }) => (
  <Card className={`hl-feature-card hl-feature-card--${color} h-100 hover-shadow`}>
    <CardBody className="d-flex flex-column">
      <div className="d-flex justify-content-between align-items-start">
        <span className={`hl-icon-tile hl-icon-tile--${color}`} aria-hidden="true">
          <FontAwesomeIcon icon={icon} fixedWidth />
        </span>
        {meta}
      </div>
      <h3 className="hl-feature-card__title">
        {onClick ? (
          <a href="#!" onClick={clickable(onClick)} className="stretched-link text-900">
            {title}
          </a>
        ) : (
          <Link to={to} className="stretched-link text-900">
            {title}
          </Link>
        )}
        <ArrowRight
          size={16}
          strokeWidth={2.25}
          className="hl-feature-card__arrow"
          aria-hidden="true"
        />
      </h3>
      <p className="hl-feature-card__text">{description}</p>
      {action && (
        // Por encima del stretched-link para que el clic no abra la vista.
        <Link
          to={action.to}
          className="hl-feature-card__link position-relative mt-auto pt-2"
          style={{ zIndex: 2 }}
        >
          <Plus size={14} strokeWidth={2.25} className="mr-1" aria-hidden="true" />
          {action.label}
        </Link>
      )}
    </CardBody>
  </Card>
);

const linkTarget = PropTypes.oneOfType([PropTypes.string, PropTypes.object]);

HubLinkCard.propTypes = {
  to: linkTarget,
  onClick: PropTypes.func,
  icon: PropTypes.object.isRequired,
  color: PropTypes.string,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  meta: PropTypes.node,
  action: PropTypes.shape({ to: linkTarget.isRequired, label: PropTypes.string.isRequired }),
};

export default HubLinkCard;
